module.exports = __webpack_public_path__ + "img/menu-hide.b1ccb7e8.svg";